import { IconProps } from './IconProps';

export const ChevronRight = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="7"
      height="12"
      viewBox="0 0 7 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 1.29054L4.54713 6.01684L0.030223 10.8033L1.19687 12L7 6.07697L1.2566 0.0643415L0 1.29054Z"
        fill={props.fill || "black"}
      />
    </svg>
  );
};
